import Icon from '@mui/material/Icon'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import IconText from '@/app/component/layout/icon-text'

type Props = {
  children: React.ReactNode
  hideInfo?: boolean
  message: string
  messageCountable?: string
  name: string
  showPersonalizationInfo?: boolean
}

const InputWhatsApp: React.FC<Props> = ({
  children,
  hideInfo = false,
  message,
  messageCountable,
  name,
  showPersonalizationInfo = false,
}) => {
  const countable = messageCountable ?? message

  return (
    <div style={{ position: 'relative' }}>
      {children}
      {!hideInfo && (
        <Container className={`${name}-message-info`}>
          <TextContainer>
            {showPersonalizationInfo && (
              <IconText>
                <Icon color="action">info</Icon>
                <Typography variant="caption" color="textSecondary">
                  The character counter assumes a length of 20 for each template variable.
                </Typography>
              </IconText>
            )}
          </TextContainer>
          <Typography color="textSecondary" data-testid={`${name}-whatsapp-character-counter`}>
            {showPersonalizationInfo ? 'about ' : ''}
            {countable.length} characters
          </Typography>
        </Container>
      )}
    </div>
  )
}

const Container = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '1rem',
})

const TextContainer = styled('div')({
  flex: 1,
})

export default InputWhatsApp
